import PropTypes from 'prop-types';
import React from 'react';
import Tappable from '../commons/Tappable';

const propTypes = {
  children: PropTypes.node,
  hideText: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  show: PropTypes.bool,
  showText: PropTypes.string,
};

const defaultProps = {
  children: undefined,
  hideText: undefined,
  show: false,
  showText: undefined,
};

function HideAndShow({
  children,
  hideText,
  onClick,
  show,
  showText,
}) {
  if (!show) {
    return (
      <Tappable onTap={onClick}>
        <span className="ion-android-add-circle" />&nbsp;{showText}
      </Tappable>
    );
  }

  return (
    <fieldset>
      <Tappable component="legend" onTap={onClick}>
        <span className="ion-android-remove-circle" />&nbsp;{hideText}
      </Tappable>
      {children}
    </fieldset>
  );
}

HideAndShow.propTypes = propTypes;
HideAndShow.defaultProps = defaultProps;

export default HideAndShow;
